import { gql } from '@apollo/client/core'
import { useQuery } from '@vue/apollo-composable'
import { IBreadcrumbsQuery, IListNodeNavigationResponse } from '@types'

const GET_BREADCRUMB_NODES_QUERY = gql`
  query Query($id: ID!) {
    getBreadcrumbNodes(id: $id) {
      type
      payload {
        ... on NodeNavigationListResponse {
          nodeNavigationList {
            title
            type
            id
            id_parent
          }
        }
      }
    }
  }
`

export const useBreadcrumbsQuery = (variables: IBreadcrumbsQuery) => {
  return useQuery<IListNodeNavigationResponse>(GET_BREADCRUMB_NODES_QUERY, variables, {
    fetchPolicy: 'cache-first'
  })
}
